import ApiPaths from './ApiEndpoints';
import Identifiers from './Identifiers';

export const ApiEndpoints = new ApiPaths();
export const ApiIdentifers = new Identifiers();
